import React from "react";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { Delete16Regular } from "@fluentui/react-icons";
import { ACTIVE_BG } from "../chat/chatTheme";

/**
 * T-65 — Papierkorb-Knopf in der Mail-Zeile, wie in Outlook: erscheint beim
 * Hovern an der Stelle der Uhrzeit. Die Ein-/Ausblende-Regel steht an der Zeile
 * (Klassen `kmvs-row-actions` / `kmvs-row-time`, siehe MailView `mailItem`), ob
 * er überhaupt gerendert wird, entscheidet `zeigeHoverLoeschen`.
 *
 * Der Klick darf die Zeile NICHT öffnen — er löscht nur. Gelöscht wird wie über
 * das Kontextmenü (Verschieben nach „Gelöscht", mit Rückgängig-Hinweis).
 */
export const MAIL_ZEILE_AKTIONEN_KLASSE = "kmvs-row-actions";
export const MAIL_ZEILE_ZEIT_KLASSE = "kmvs-row-time";

const BRAND_PURPLE = "#4d2051";

const useStyles = makeStyles({
    knopf: {
        width: "24px",
        height: "24px",
        ...shorthands.padding("0"),
        ...shorthands.border("0", "none", "transparent"),
        ...shorthands.borderRadius("50%"),
        backgroundColor: "transparent",
        color: tokens.colorNeutralForeground2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        ":hover": {
            backgroundColor: ACTIVE_BG,
            color: BRAND_PURPLE,
        },
        ":focus-visible": {
            outlineWidth: "2px",
            outlineStyle: "solid",
            outlineColor: BRAND_PURPLE,
            outlineOffset: "-2px",
        },
        ":disabled": {
            cursor: "default",
            opacity: 0.5,
        },
    },
});

export const MailZeileLoeschen: React.FC<{ onLoeschen: () => void; busy?: boolean }> = ({ onLoeschen, busy }) => {
    const styles = useStyles();
    return (
        <button
            type="button"
            className={styles.knopf}
            aria-label="In den Papierkorb verschieben"
            title="Löschen"
            disabled={busy}
            onClick={(e) => {
                e.stopPropagation();
                onLoeschen();
            }}
            // Rechtsklick auf den Knopf soll nicht das Zeilen-Kontextmenü öffnen.
            onContextMenu={(e) => e.stopPropagation()}
        >
            <Delete16Regular />
        </button>
    );
};
